module.exports = __webpack_public_path__ + "img/1.5b33c68f.png";